import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/Home';
import Tours from './pages/tours/Tours';
import TourDetail from './pages/tours/TourDetail';
import Blog from './pages/blog/Blog';
import BlogPost from './pages/blog/BlogPost';
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import Dashboard from './pages/admin/Dashboard';
import DashboardTours from './pages/admin/DashboardTours';
import DashboardBlogs from './pages/admin/DashboardBlogs';
import DashboardBookings from './pages/admin/DashboardBookings';
import DashboardDiscounts from './pages/admin/DashboardDiscounts';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/tours/:id" element={<TourDetail />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<Dashboard />} />
          <Route path="/admin/dashboard/tours" element={<DashboardTours />} />
          <Route path="/admin/dashboard/blogs" element={<DashboardBlogs />} />
          <Route path="/admin/dashboard/bookings" element={<DashboardBookings />} />
          <Route path="/admin/dashboard/discounts" element={<DashboardDiscounts />} />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
